import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import { Activity, List, Sigma, Users } from 'lucide-react';
import React from 'react'
import { useGetRecipientListSummary } from '../hooks';

const RecipientDashboard = () => {
  const { data: recipientListSummary } = useGetRecipientListSummary();
   const statsData = [
    {
      title: "Total Lists",
      count: recipientListSummary?.totalLists || 0,
      icon: <List className="h-8 w-8 text-blue-500" />,
    },
    {
      title: "Active Lists",
      count: recipientListSummary?.activeLists || 0,
      icon: <Activity className="h-8 w-8 text-blue-500" />,
    },
    {
      title: "Total Recipients",
      count: recipientListSummary?.totalRecipients || 0,
      icon: <Users className="h-8 w-8 text-green-500" />,
    },
    {
      title: "Avg Recipients/List",
      count: recipientListSummary?.avgRecipientsPerList || 0,
      icon: <Sigma className="h-8 w-8 text-orange-500" />,
    },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
        />
      ))}
    </div>
  );
}

export default RecipientDashboard